const DISCLAIMERS = {
    CASH: {
        VEHICLE_DESCRIPTION: 1,
        SELLING_PRICE: 2,
        INCLUDED_REBATES: 3,
        INCLUDED_FEES: 4,
        EXCLUDED_FEES: 5,
    },
    FINANCE: {
        VEHICLE_DESCRIPTION: 1,
        TERM: {
            SELLING_PRICE: 2,
            INCLUDED_REBATES: 3,
            INCLUDED_FEES: 4,
            EXCLUDED_FEES: 5,
            TERM_APR: 6,
        },
        PAYMENT_FREQUENCY: {
            PAYMENT_CASH_DOWN: 7,
            TOTAL_OBLIGATION: 11,
            COST_OF_CREDIT: 12,
            CREDIT_RATE: 13,
        },
        KM_PLAN: 0,
        CREDIT_APPROVAL: 14,
        CASH_DOWN_TAX_EXCLUDED: 15,
    },
    LEASE: {
        VEHICLE_DESCRIPTION: 1,
        TERM: {
            SELLING_PRICE: 2,
            INCLUDED_REBATES: 3,
            INCLUDED_FEES: 4,
            EXCLUDED_FEES: 5,
            TERM_APR: 6,
        },
        PAYMENT_FREQUENCY: {
            PAYMENT_CASH_DOWN: 7,
            TOTAL_OBLIGATION: 11,
            COST_OF_CREDIT: 35,
            CREDIT_RATE: 0,
        },
        KM_PLAN: 11,
        CREDIT_APPROVAL: 12,
        CASH_DOWN_TAX_EXCLUDED: 13,
    },
    GENERAL_FEES_EXCLUSION: 1,
    PRICES_SUBJECT_TO_CHANGE: 2,
    NOT_RESPONSIBLE: 3,
    HIGH_TRANSACTION_VOLUME: 4,
    ILLUSTRATION_PURPOSES: 6,
    OPTIONS_TRIMS_VARIATION: 7,
    EXCLUDED_TAXES: 9,
    PRICE_PAYMENTS_EXCLUDED_TAXES: 11,
};

export default DISCLAIMERS;
